import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { encryptData, decryptData } from "../utils/encryptionUtils"; // Adjust the path as needed
import { decodeJWT } from "../utils/commonUtils"; // Assuming this exists
import { setCredentials, clearCredentials } from "../store/appSlices";

export const useAuth = () => {
    const dispatch = useDispatch();
    const authData = useSelector((state) => state.auth);

    const isValidToken = (token) => {
        try {
            const decodedToken = decodeJWT(token); // Assuming you're decoding the JWT.

            // Check expiration
            const now = Date.now() / 1000; // Current time in seconds
            return decodedToken.exp && decodedToken.exp > now;
        } catch (error) {
            return false;
        }
    };

    const storeAuthData = (data) => {
        const authData = {
            accessToken: data?.accessToken,
            refreshToken: data?.refreshToken,
        };

        // const authData = {
        //     accessToken: data?.tokens?.access,
        //     refreshToken: data?.tokens?.refresh,
        //     // user: data?.user,
        // };

        // Encrypt tokens and user data before storing in local storage
        localStorage.setItem("auth", encryptData(authData));

        // Dispatch action to update Redux state
        dispatch(setCredentials(authData));
    };

    const clearAuthData = () => {
        localStorage.removeItem("auth");
        sessionStorage.clear();
        dispatch(clearCredentials());
    };

    useEffect(() => {
        const handleStorageEvent = (event) => {
            if (!event.key) {
                return;
            }

            if (event.key === "clearSessions") {
                sessionStorage.clear();
                dispatch(clearCredentials());
            } else if (event.key === "auth") {
                const newAuth = event.newValue ? decryptData(event.newValue) : null;

                if (newAuth) {
                    if (isValidToken(newAuth.accessToken)) {
                        dispatch(setCredentials(newAuth));
                    } else {
                        dispatch(clearCredentials());
                        sessionStorage.clear();
                    }
                } else {
                    dispatch(clearCredentials());
                    sessionStorage.clear();
                }
            }
        };

        // Attach storage event listener
        window.addEventListener("storage", handleStorageEvent);

        // Load initial auth state on mount
        const storedAuth = localStorage.getItem("auth");
        if (storedAuth) {
            const parsedAuth = decryptData(storedAuth);
            if (parsedAuth) {
                if (isValidToken(parsedAuth.accessToken)) {
                    dispatch(setCredentials(parsedAuth));
                } else {
                    clearAuthData();
                    sessionStorage.clear();
                }
            } else {
                console.error("Failed to decrypt auth data.");
            }
        }

        // Cleanup on component unmount
        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, [dispatch]);

    return { authData, storeAuthData, clearAuthData };
};
